import {appAPI} from "../../../api";
import {INewTask, ITask} from "../../../models/IMachineryTasks";

const machineryTasksPath = `/machinery-task`;

const prepareTaskDto = (dto: INewTask) => {
    if (!dto.assigned_to_id || dto.assigned_to_id === "-1") delete dto.assigned_to_id;
    if (!dto.problem_id || dto.problem_id === "-1") delete dto.problem_id;
    // if (!dto.machinery_id || dto.machinery_id === "-1") delete dto.machinery_id;
    return dto;
};

/**
 * Payload обновления задачи: только скаляры и FK-id из UpdateMachineryTaskDto.
 * Relation-объекты (author, machinery, maintenance_template, problem,
 * assigned_to, updated_author) НЕ отправляем — они тяжёлые и провоцируют
 * на бэке коллизию "relation-объект перебивает FK-скаляр" при save.
 */
const prepareUpdatePayload = (task: ITask) => ({
    id: task.id,
    title: task.title,
    description: task.description,
    type_id: Number(task.type_id),
    status_id: Number(task.status_id),
    priority_id: Number(task.priority_id),
    due_date: Number(task.due_date),
    event_location: task.event_location,
    issue_operating: Number(task.issue_operating),
    issue_odometer: Number(task.issue_odometer),
    issue_photos: task.issue_photos ?? [],
    machinery_id: task.machinery_id,
    assigned_to_id: task.assigned_to_id,
    problem_id: task.problem_id,
    maintenance_template_id: task.maintenance_template_id ?? null,
    extra_works: task.extra_works ?? "",
    result_date: Number(task.result_date),
    result_odometer: Number(task.result_odometer),
    result_operating: Number(task.result_operating),
    result_description: task.result_description ?? "",
    result_spent_resources: task.result_spent_resources ?? "",
    result_photos: task.result_photos ?? [],
});

export const machineryTasksAPI = {
    add: async (newTask: INewTask) => {
        const prepareTask = prepareTaskDto(newTask);
        const res = await appAPI.post(machineryTasksPath, {
            ...prepareTask,
            issue_operating: Number(prepareTask.issue_operating),
            issue_odometer: Number(prepareTask.issue_odometer),
        });
        return res.data;
    },
    getAll: async () => {
        const res = await appAPI.get(machineryTasksPath);
        return res.data;
    },
    getById: async (task_id: string) => {
        const res = await appAPI.get(`${machineryTasksPath}/${task_id}`);
        return res.data;
    },
    update: async (task: ITask) => {
        const payload = prepareUpdatePayload(task);
        const res = await appAPI.put(`${machineryTasksPath}/${task.id}/`, payload);
        return res.data;
    },
    delete: async (task_id: string) => {
        const res = await appAPI.delete(`${machineryTasksPath}/${task_id}/`);
        return res.data;
    },
};